module.exports = __webpack_public_path__ + "img/map_all_general-group-seating-2.4e7c1c44.jpg";